import React from 'react';
import styles from './index.module.scss';

const SustReportDefaultAnswers = (props) => {
  const { answer } = props;

  return (
    <div className={styles.answerContainer}>
      <div key={answer.key} className={styles.answerHeader}>
        {answer.label}
      </div>
      <div>
        <div>
          {answer.type === 'string' && answer.answer}
          {answer.type === 'multiple' && (
            <div>
              {answer.answer.map((det) =>
                Object.keys(det).map((key) => <div>{`${key}: ${det[key]}`}</div>)
              )}
            </div>
          )}
        </div>
        <div className={styles.icon}>{answer.icon}</div>
      </div>
    </div>
  );
};

export default SustReportDefaultAnswers;
